import React, { Fragment, useEffect, useState, useCallback } from "react";

//Vapor Components
import Stack from "@vapor/react-material/Stack";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import Modal from "@vapor/react-material/Modal";
import Divider from "@vapor/react-material/Divider";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import {useQuery } from "@1f/react-sdk";
import {userModel} from "../../../businessLogic/models"
import { useSnackbar } from "notistack";

//Vapor Date Pickers
import { AdapterDateFns } from "@vapor/react-x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@vapor/react-x-date-pickers/LocalizationProvider";
import { DatePicker } from "@vapor/react-x-date-pickers/DatePicker";
import { it } from "date-fns/locale";

//Style
import {  modalStyleLarge } from "../../../businessLogic/styles";
import { useTranslation } from "@1f/react-sdk";
import { query_users_byTenantId } from "../../../businessLogic/query/userQueries";
import { isDateValid } from "../../../businessLogic/helpers/dateHelpers";
import { Autocomplete, TextField } from "@vapor/react-material";
import { LogApi } from "../../../businessLogic/api/logApi";
import sharedDatasInstance from "../../../businessLogic/sharedDatas";

export const ModalNominationAdd = ({show, onClose, onOk, tenantId, userFromParent, selectedRoleFromParent}) =>{

    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const possibleRoles = [
        {value: "revisore_indipendente", label: "Revisore indipendente"},
        {value: "responsabile_antiriciclaggio", label: "Responsabile antiriciclaggio"},
        {value: "sos_referente", label : "Referente SOS"}
    ];
    const aziendaName = sharedDatasInstance.getPropertyByName("aziendaName");
    const [allUsers, setAllUsers] = useState([])
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const [selectedRole, setSelectedRole] = useState("")
    const [selUser, setSelUser] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [UIFSignUpDate, setUIFSignUpDate] = useState(null) 
    const [isLoading, setIsLoading] = useState(false)

    const usersByTenant = useQuery(
        query_users_byTenantId,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const logApi = LogApi();

    const loadUsers = useCallback(async () => {
        setIsLoading(true);
        try {
            const allUsersResponse = await usersByTenant.fetch({
                tenantId: tenantId,
            });
            const arrAllUsers = [];
            allUsersResponse.data.data.user_tenant.forEach((item) => {
                arrAllUsers.push(
                    new userModel(
                        item.UserId,
                        item.TenantId,
                        item.user.Username,
                        item.user.Email,
                        item.user.Name,
                        item.user.Surname,
                        item.user.Name + " " + item.user.Surname,
                        item.Type,
                        item.user.Locale,
                        item.TenantTipoId,
                        item.user.IsRespAntiRic,
                        item.base_tipo_tenant.Value,
                        item.user.IsActive,
                        item.user.IsDeleted,
                        item.user.IsBanned,
                        item.user.CreatedOn,
                        item.user.Cf
                    )
                )
            });
            setAllUsers(arrAllUsers)
            setIsDataLoaded(true)
        } catch (error) {
            logApi.AddLog(error.message, error.stack, "loadUsers", "ModalNominationAdd")
        } finally {
            setIsLoading(false);
        }
    }, [tenantId, usersByTenant, logApi]);

    // Carica gli utenti solo quando la modale si apre
    useEffect(() => {
        if (show && !isDataLoaded) {
            loadUsers();
        }
    }, [show, isDataLoaded, loadUsers]);

    // Inizializza i valori quando la modale si apre o quando cambia userFromParent
    useEffect(() => {
        if (show) {
            if (userFromParent !== null) {
                // Modalità EDIT
                setSelectedRole(possibleRoles.find(r => r.value === selectedRoleFromParent)?.label || "")
                setSelUser(userFromParent.user)
                setStartDate(userFromParent.dateStart ? new Date(userFromParent.dateStart) : null)
                setEndDate(userFromParent.dateEnd ? new Date(userFromParent.dateEnd) : null)
                setUIFSignUpDate(userFromParent.sosUserDateRegUif ? new Date(userFromParent.sosUserDateRegUif) : null)
            } else {
                // Modalità CREATE
                setSelectedRole(possibleRoles.find(r => r.value === selectedRoleFromParent)?.label || "")
                setSelUser(null)
                setStartDate(null)
                setEndDate(null)
                setUIFSignUpDate(null)
            }
        }
    }, [show, userFromParent, selectedRoleFromParent]);

    // Resetta lo state quando la modale si chiude
    const resetState = () => {
        setSelectedRole("")
        setSelUser(null)
        setStartDate(null)
        setEndDate(null)
        setUIFSignUpDate(null)
    }

    //Actions
    const handleModalClose = (e) => {
        resetState();
        onClose(e);
    };

    const handleModalOk = (e) => {
        // Validazione
        if (!selUser) {
            enqueueSnackbar("Seleziona un utente",{ variant: 'warning' });
            return;
        }
        if (!selectedRole) {
            enqueueSnackbar("Seleziona un ruolo",{ variant: 'warning' });
            return;
        }
        if (!startDate || !isDateValid(startDate)) {
            enqueueSnackbar("Inserisci una data di inizio valida",{ variant: 'warning' });
            return;
        }
        if (endDate && !isDateValid(endDate)) {
            enqueueSnackbar("Inserisci una data di fine valida",{ variant: 'warning' });
            return;
        }
        if (endDate && startDate && new Date(endDate) < new Date(startDate)) {
            enqueueSnackbar("La data di fine non può essere precedente alla data di inizio",{ variant: 'warning' });
            return;
        }
        if(selectedRole === "Referente SOS" && (!UIFSignUpDate || !isDateValid(UIFSignUpDate))){
            enqueueSnackbar("Inserisci una data di registrazione al portale UIF valida",{ variant: 'warning' });
            return;
        }

        onOk(selUser, startDate, endDate, selectedRole, UIFSignUpDate);
        resetState();
    };

    const handleChangeRole = (event, value) => {
        setSelectedRole(value)
    }

    const handleChangeUser = (event, value) => {
        setSelUser(value)
    }

    const handleChangeStartDate = (date) => {
        if (date !== null && isDateValid(date)) {
            setStartDate(date)
            // Se la data di fine è precedente alla nuova data di inizio, resettala
            if (endDate && new Date(date) > new Date(endDate)) {
                setEndDate(null)
            }
        } else {
            setStartDate(null)
            setEndDate(null)
        }
    }

    const handleChangeEndDate = (date) => {
        if (date !== null && isDateValid(date)) {
            setEndDate(date)
        } else {
            setEndDate(null)
        }
    }

    const handleChangeUIFSignUpDate = (date) => {
        if (date !== null && isDateValid(date)) {
            setUIFSignUpDate(date)
        } else {
            setUIFSignUpDate(null)
        }
    }

    return (
        <Fragment>
            <Modal
                key="nominationAddModal"
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                open={show}
                onClose={handleModalClose}
                onOk={handleModalOk}
            >
                <Box sx={modalStyleLarge}>
                    <Stack
                        direction="column"
                        spacing={0}
                        justifyContent="left"
                        alignItems="left"
                    >
                        <ExtendedTypography
                            variant="titleSmall"
                            color="primary.main"
                            sx={{ p: 2, pl: 3 }}
                        >
                            {userFromParent !== null ? "Aggiorna informazioni dell'utente" : "Nomina un nuovo utente"}
                        </ExtendedTypography>
                        <Divider orientation="horizontal" flexItem />

                        <Stack sx={{p : 2}} spacing={2}>
                            <Autocomplete
                                id="ddlAzienda"
                                key={`azienda-${aziendaName}`}
                                size="small"
                                options={{}}
                                sx={{ width: "100%" }}
                                fullWidth
                                value={aziendaName || null}
                                disabled={true}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label="Soggetto obbligato"
                                        sx={{ lineHeight: 2 }}
                                    />
                                )}
                            />
                            <Autocomplete
                                id="ddlModalRole"
                                key={`role-${selectedRole}`}
                                size="small"
                                options={possibleRoles}
                                sx={{ width: "100%" }}
                                fullWidth
                                onChange={handleChangeRole}
                                value={selectedRole || null}
                                disabled={userFromParent !== null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label="Ruolo"
                                        sx={{ lineHeight: 2 }}
                                    />
                                )}
                            />                               
                            <Autocomplete
                                id="ddlModalUsers"
                                key={`user-${selUser?.userId || 'empty'}`}
                                size="small"
                                options={allUsers}
                                sx={{ width: "100%" }}
                                fullWidth
                                loading={isLoading}
                                onChange={handleChangeUser}
                                value={selUser}
                                getOptionLabel={(option) =>
                                    allUsers.filter(x=>x.userId === option.userId).length > 0
                                    ? allUsers.filter(x=>x.userId === option.userId)[0].completeName
                                    : ""}
                                isOptionEqualToValue={(option, value) => option?.userId === value?.userId}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label="Utente"
                                        sx={{ lineHeight: 2 }}
                                    />
                                )}
                            />
                            <Stack direction="row" spacing={2}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={it}
                                >
                                    <DatePicker
                                        label="Dal"
                                        closeOnSelect
                                        format="dd/MM/yyyy"
                                        mask="__/__/____"                                        
                                        maxDate={new Date()}
                                        value={startDate}
                                        onChange={handleChangeStartDate}
                                        slotProps={{
                                            textField: {
                                                placeholder: "dd/MM/yyyy",
                                                size: "small",
                                                fullWidth: true,
                                            },
                                        }}
                                    />
                                    <DatePicker
                                        label="Al"
                                        closeOnSelect
                                        format="dd/MM/yyyy"
                                        mask="__/__/____"
                                        minDate={startDate && isDateValid(startDate) ? new Date(startDate) : null}
                                        value={endDate}
                                        onChange={handleChangeEndDate}
                                        slotProps={{
                                            textField: {
                                                placeholder: "dd/MM/yyyy",
                                                size: "small",
                                                fullWidth: true,
                                            },
                                        }}
                                        disabled={!startDate || !isDateValid(startDate)}
                                    />
                                </LocalizationProvider>
                            </Stack>  
                            {selectedRole === "Referente SOS" && (
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={it}
                                >       
                                    <DatePicker
                                        label="Data registrazione portale UIF"
                                        closeOnSelect
                                        format="dd/MM/yyyy"
                                        mask="__/__/____"                                        
                                        maxDate={new Date()}
                                        value={UIFSignUpDate}
                                        onChange={handleChangeUIFSignUpDate}
                                        slotProps={{
                                            textField: {
                                                placeholder: "dd/MM/yyyy",
                                                size: "small",
                                                fullWidth: true,
                                            },
                                        }}/>                                    
                                </LocalizationProvider>                          
                            )}
                        </Stack>
                    </Stack>
                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{ p: 1, mt: 1, bgcolor: "#F2F5F8" }}
                        justifyContent="right"
                        alignItems="right"
                    >
                        <Button variant="outlined" size="small" onClick={handleModalClose}>
                            {t("actions.annulla")}
                        </Button>
                        <Button variant="contained" size="small" onClick={handleModalOk}>
                            {userFromParent!== null ? t("actions.aggiorna") : t("actions.salva")}
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </Fragment>
    );
}